<template>
  <a-spin :spinning="loading">
    <div class="row">
      <div class="col-12 text-md-right mb-2 d-print-none">
        <add-exam-remark :enrollmentId="student.id" :classSectionExamId="examData.id" @created="handleTableUpdate"/>
      </div>
      <div class="col-12" v-if="remarksData">
        <student-exam-remarks-table :data="remarksData" :enrollmentId="student.id" :classSectionExamId="examData.id" @updateTable="handleTableUpdate" />
      </div>
    </div>
  </a-spin>
</template>

<script>
import StudentExamRemarksTable from './Table/index'
import AddExamRemark from './Add/index'

export default {
  name: 'StudentExamRemarks',
  components: {
    StudentExamRemarksTable,
    AddExamRemark,
  },
  props: ['student', 'examData', 'remarksData'],
  mounted: function() {
    // this.$eventBus.$on('studentChangedExamMarksReport', this.getStudentRemarks)
  },
  data: function() {
    return {
      loading: false,
      data: null,
    }
  },
  methods: {
    // getStudentRemarks() {
    //   this.loading = true
    //   this.$http
    //     .get(`/api/studentexamremarks/${this.student.id}`, {
    //       params: {
    //         class_section_exam_id: this.examData.id,
    //       },
    //     })
    //     .then(({ data }) => {
    //       this.loading = false
    //       this.data = data.data
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    handleTableUpdate() {
      // this.getStudentRemarks()
      this.$emit('updateTable')
    },
  },

}
</script>
